import { render } from "./ItemCarousel.vue?vue&type=template&id=c5d135e4&scoped=true&ts=true"
import script from "./ItemCarousel.vue?vue&type=script&lang=ts"
export * from "./ItemCarousel.vue?vue&type=script&lang=ts"

import "./ItemCarousel.vue?vue&type=style&index=0&id=c5d135e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5d135e4"]])

export default __exports__